<template name="invisitList">
  <div class="invisitListContent">
    <div>
      <span v-if="visitListType == 'cc'" class="bold">
        {{$t('ccList')}}
      </span>
      <span v-else-if="visitListType == 'warehouse'" class="bold">
        {{$t('ReceiptShippingList')}}
      </span>
      <span v-else class="bold">
        {{this.visitListType == 'check' ? this.$t('WaitingApproval') : this.visitListType == 'today' ? this.$t('Today') : ''}}{{$t('InvitationList')}}
      </span>
      <i class="iconfont icon-close" @click="closeList"></i>
    </div>
    <div class="ko-list-header">
      <div class="inner">
        <div class="row">
          <div class="col-10">
            <i class="iconfont icon-search"></i>
            <input type="" name="" class="form-control" :placeholder="$t('searchCondition')" v-model="keywords" @focus="focusOrBlur" @blur="focusOrBlur">
            <i class="iconfont icon-close clear-input" @click="clearInput" v-show="keywords.trim().length"></i>
          </div>
          <div class="search-btn col-2">
            <button class="btn" :class="{ searchable: keywords.trim() }" @click="getInviteList(visitListType)" :disabled="!keywords.trim()">{{ $t('Search') }}</button>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="nav-tab" v-if="this.tabs.tabs != undefined" :class="this.tabs.subTabs.length ? '' : 'no-subtabs'">
        <div class="tab row" :class="[this.tabs.tabs.length == 2 ? 'tab-center' : 'tab']">
          <div class="tab-col bold" 
            :class="item.active"
            v-for="(item, index) in this.tabs.tabs" :data-index="index" @click="active(index)">
            {{item.name}}
          </div>
        </div>
        <div class="row tab-list" v-if="this.tabs.subTabs.length">
          <div :class="item.active" v-for="(item, index) in this.tabs.subTabs" :data-index="index" @click="activeRole(index)">{{item.name}}</div>
        </div>
      </div>
      <div class="dataList" id="dataList" v-infinite-scroll="this.getMoreList" infinite-scroll-disabled="isLoading" infinite-scroll-distance="100" infinite-scroll-immediate-check="true">
        <div class="no-list" v-if="!this.activevisitList.length" v-show="!this.isLoading">
          <div class="inner" v-if="searched">
            <img src="../assets/images/search-no-result@2x.png" class="icon">
            <h5>{{ $t('NoResult') }}</h5>
          </div>
          <div class="inner" v-else>
            <img src="../assets/images/no-result@2x.png" class="icon">
            <h5>{{ $t('NoInvitationForThisList') }}</h5>
            <p>{{ $t('NoInvitationInfo') }} </p>
          </div>
        </div>
        <ul>
          <li v-for="(item, index) in this.activevisitList">
            <router-link :to="'/inviteDetail/' + item.ticketId">
              <div class="row">
                <div class="col-9">
                  <div class="top">
                    <span class="radius-list" ></span>
                    <span class="title bold" :class="item.ticketStatus == 32 || item.ticketStatus == 52 ? 'title-grey' : ''" v-if="visitListType == 'warehouse'">
                      {{item.title}}
                    </span>
                    <span class="title bold" v-else>
                      {{item.title}}
                    </span>
                  </div>
                </div>
                <div class="col-3 col-status">
                  <span class="statuslist bold" :class="item.ticketStatus == 32 || item.ticketStatus == 52 ? 'today-status-out' : 'today-status'" v-if="visitListType == 'warehouse'">
                    {{item.ticketStatusDesc}}
                  </span>
                  <span class="statuslist bold today-status" v-else>
                    {{item.CheckStatusText}}
                  </span>
                </div>
              </div>
              <div class="bottom">
                <div class="">
                  <i class="iconfont icon-shenfenzheng"></i>
                  <span>{{item.visitTicketUserRoleDesc}}</span>
                </div>
                <div class="">
                  <i class="iconfont icon-renyuanguanli"></i>
                  <span>{{item.visitorNumber}}{{ $t('People') }}</span>
                </div>
                <div class="">
                  <i class="iconfont icon-clock"></i>
                  <span>{{item.startTime}} - {{item.endTime}}</span>
                </div>
                <div class="" v-if="visitListType == 'warehouse'" v-show="item.carNumber != ''">
                  <i class="iconfont icon-car"></i>
                  <span>{{item.carNumber}}</span>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
   <loading :active.sync="isLoading" :color="'#e42029'"></loading>
 </div>
</template>

<script type="text/javascript">;
import Vue from "vue";
import { getInviteListByCheck, getInviteListByToday, getInviteListAll, getInviteListCC, getInviteListWarehouse } from '@/utils/api';
import { checkNested } from '@/utils/utils';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import infiniteScroll from 'vue-infinite-scroll';

Vue.use(infiniteScroll);
const MobileDetect = require('mobile-detect');

const md = new MobileDetect(window.navigator.userAgent);
const isPhone = !!md.phone();
const winHeight = window.innerHeight;
export default {
  name: 'invisitList',
  props: ['visitListType', 'tabs'],
  data() {
    return {
      searched: false,
      modalView: false,
      activevisitList: [],
      visitListCount: 0,
      focused: false,
      searchTxt: '',
      searchbtn: false,
      number: '0',
      isButtonDisabled: true,
      pageIndex: 1,
      pageCount: 10,
      totalPages: 0,
      keywords: '',
      checkStatus: 1,
      isLoading: false,
      isAllLoaded: false,
      tabStatus: 1,
      subTabStatus: 0,
      targetDate: 1,
    };
  },
  components: {
    Loading,
  },
  watch: {
    visitListType: function() {
      this.getInviteList(this.visitListType);
    },
    'searchTxt':{ // 监听搜索框是否有值
      handler(searchTxt) {
        var _this = this;
        var _sum = 100;
        _this.$refs.count.setAttribute("maxlength",_sum);//设置输入框的最大长度
        if(searchTxt != '') {
          this.searchbtn = true;
          this.focused = true;
          this.isButtonDisabled = false;
        } else {
          this.searchbtn = false;
          this.focused = false;
          this.isButtonDisabled = true;
        }
      },
      deep:true
    },
  },
  methods: {
    active: function (dataIndex) {
      var newVisitList = this.visitList;
      var newTabs = this.tabs.tabs;
      const type = this.visitListType;
      //const index = parseInt(e.target.dataset.index);
      const index = dataIndex;
      for (let i = 0; i < newTabs.length; i += 1) {
        if (i == index) {
          newTabs[i].active = 'active';
        } else {
          newTabs[i].active = '';
        }
      }
      this.tabStatus = index + 1;
      this.getInviteList(type);
    },
    activeRole: function(dataIndex) {
      var newVisitList = this.visitList;
      var newTabs = this.tabs.subTabs;
      //const index = parseInt(e.target.dataset.index);
      const index = dataIndex;
      for(let i = 0; i < newTabs.length; i += 1) {
        if (index == i) {
          newTabs[i].active = 'active';
          this.subTabStatus = index;
        } else {
          newTabs[i].active = '';
        }
      }
      this.getInviteList(this.visitListType);
    },
    closeList: function closeList() {
      this.$emit('getMessage', this.modalView);
      this.$emit('getVisitListType', '');
      this.activevisitList = [];
      this.searchTxt = '';
      this.pageIndex = 1;
      this.pageCount = 10;
      this.totalPages = 0;
      this.keywords = '';
      this.checkStatus = 1;
      this.isLoading = false;
      this.isAllLoaded = false;
      this.tabStatus = 1;
      this.subTabStatus = 0;
      this.targetDate = 1;
    },
    bindData: function(res, isMore) {
      if (checkNested(res, 'data', 'content', 'model', 'entities')) {
        if (isMore) {
          this.activevisitList = [...this.activevisitList, ...res.data.content.model.entities];
        } else {
          this.activevisitList = res.data.content.model.entities;
        }
        this.totalPages = res.data.content.model.totalPages;
        this.isAllLoaded = this.pageIndex === this.totalPages;

        this.pageIndex = this.pageIndex < this.totalPages
        ? this.pageIndex + 1 : this.totalPages;
      }
    },
    getInviteList: function(type, isMore) {
      this.isLoading = true;
      this.searched = this.keywords === '' ? false : true;
      if (!isMore) {
        this.pageIndex = 1;
      }
      if (type == 'check') {
        getInviteListByCheck(this.pageIndex, this.pageCount, this.keywords, this.subTabStatus, this.tabStatus).then((res) => {
          this.isLoading = false;
          this.bindData(res, isMore);
        });
      } else if (type == 'today') {
        getInviteListByToday(this.pageIndex, this.pageCount, this.keywords, this.tabStatus, this.subTabStatus).then((res) => {
          this.isLoading = false;
          this.bindData(res, isMore);
        });
      } else if (type == 'all') {
        getInviteListAll(this.pageIndex, this.pageCount, this.keywords, this.tabStatus, this.subTabStatus).then((res) => {
          this.isLoading = false;
          this.bindData(res, isMore);
        });
      } else if (type == 'cc') {
        getInviteListCC(this.pageIndex, this.pageCount, this.keywords, this.tabStatus).then((res) => {
          this.isLoading = false;
          this.bindData(res, isMore);
        });
      } else if (type == 'warehouse') {
        getInviteListWarehouse(this.pageIndex, this.pageCount, this.keywords, this.tabStatus, this.subTabStatus).then((res) => {
          this.isLoading = false;
          this.bindData(res, isMore);
        });
      }
    },
    getMoreList: function() {
      if (!this.isAllLoaded) {
        this.getInviteList(this.visitListType, true);
      }
    },
    clearInput() {
      this.keywords = '';
    },
    focusOrBlur() {
      const delay = 100;
      if (isPhone) {
        const timerId = setInterval(() => {
          const currentWinHeight = window.innerHeight;
          if ((winHeight - currentWinHeight) > 50) {
            this.isFooterShown = false;
          // clearInterval(timerId);
          } else {
            this.isFooterShown = true;
          // clearInterval(timerId);
          }
        }, delay);
      }
    },
  },
  created: function () {
    // const newVisitList = this.visitList;
    // this.visitListCount = this.visitList.tabArr.length;
    // const activeStatus = newVisitList.tabArr[0].status;
    // this.activevisitList = newVisitList.listArr.filter(function(item,index) {
    //   return (activeStatus.indexOf(item.status) !== -1);
    // });
  },
};
</script>

<style scoped lang="scss">
.bold {
  font-weight: bold;
}
.no-list {
  padding-top: 60px;
  text-align: center;
  .icon {
    width: 86px;
    height: 86px;
    margin: 0 auto 15px;
  }
  h5,
  p {
    font-size: 13px;
  }
  h5 {
    font-weight: bold;
  }
  .btn-back {
    width: 125px;
    height: 42px;
    font-size: 15px;
    line-height: 28px;
    color: #fff !important;
    margin-top: 5px;
    padding: 6px 12px !important;
    display: inline-block !important;
    background-image: linear-gradient(69deg, #f36443, #e42029) !important;
    &:focus,
    &:hover {
      box-shadow: none;
    }
  }
}
.invisitListContent {
  background-color: #fff;
  border-radius: 10px 10px 0 0;
  width: 100%;
  & > div:first-child {
    width: 90%;
    margin: auto;
    padding: 20px 0 10px;
    font-size: 18px;
    color: #4a4a4a;
    // font-family: HiraginoSansGB-W6;
    i {
      display: inline-block;
      float: right;
      font-size: 22px;
    }
  }
  & > div:nth-of-type(3) {
    width: 100%;
    margin: auto;
    .row.tab {
      width: 90%;
      line-height: 30px;
      margin: 0 auto;
      border-bottom: 1px solid #f0f1f2;
      justify-content: space-between;
      &.tab-center {
        justify-content: center;
        div {
          margin: 0 10%;
        }
      }
      div {
        padding: 0;
        font-size: 14px;
        // font-family: HiraginoSansGB-W6;
        color: #394a54;
        text-align: center;
        &.active {
          color: #e42029;
          border-bottom: 3px solid #e42029;
        }
      }
    }
    .tab-list {
      width: 90%;
      margin: 0 auto;
      line-height: 18px;
      padding-top: 15px;
      padding-bottom: 10px;
      div {
        border-radius: 12.5px;
        background: rgba(216,216,216,0.45);
        font-size: 12px;
        color: #929292;
        padding: 4px 9px;
        margin-right: 10px;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
        &.active {
          background: rgb(228,32,41);
          color: #fff;
        }
      }
    }
    .dataList {
      width: 100%;
      padding: 15px 0;
      overflow-x: hidden;
      overflow-y: auto;
      height: calc(100vh - 295px);
      ul {
        width: 90%;
        margin: 0 auto;
        list-style: none;
        li {
          width: 100%;
          margin: 0 auto;
          margin-bottom: 20px;
          border-radius: 4px;
          background-color: #ffffff;
          &:last-child {
            margin-bottom: 0;
          }
          div.row {
            margin: 0;
            width: 100%;
            margin: auto;
            & > div {
              padding: 0;
              .top {
                .radius-list {
                  display: inline-block;
                  margin-right: 7px;
                  vertical-align: middle;
                  width: 12px;
                  height: 12px;
                  border-radius: 50%;
                  background-color: #ff2137;
                  border: 3px solid #ffe2ef;
                }
                .radius-list-out {
                  display: inline-block;
                  margin-right: 7px;
                  vertical-align: middle;
                  width: 12px;
                  height: 12px;
                  border-radius: 50%;
                  background-color: #919191;
                  border: 3px solid #e6e6e6;
                }
                .title {
                  font-size: 14px;
                  color: #212529;
                }
                .title-grey {
                  color: #929292;
                }
              }              
            }
            & > div:last-child {
              .today-status {
                display: inline-block;
                color: #e42029;
                font-size: 12px;
                word-break: break-word;
              }
              .today-status-out {
                display: inline-block;
                color: #929292;
                font-size: 12px;
                word-break: break-word;
              }
            }
          }
          .bottom {
            display: flex;
            padding-top: 5px;
            flex-wrap: wrap;
            div {
              padding-right: 8px;
            }
            i {
              font-size: 14px;
              color: #e42029;
            }
            span {
              font-size: 12px;
              color: #929292;
              padding-left: 5px;
            }
          }
        }
      }
      a {
        color: #212529;
        display: block;
        text-decoration: none;
        border-radius: 4px;
        background: #fff;
        padding: 15px 12px;
        box-shadow: 0 0 25px rgba(100, 100, 100, 0.3);
      }
    }
    .no-subtabs + .dataList {
      height: calc(100vh - 244px);
    }
  }
  .col-status {
    text-align: right;
  }
  .ko-list-header {
    width: 100%;
    .col-12 {
      position: relative;
    }
    i {
      position: absolute;
      line-height: 36px;       
      font-size: 18px;
    }
    i.icon-search {
      color: #999;
      top: 0;
      left: 25px;
    }
    i.icon-close {
      top: 10px;
      right: 10px;
      width: 18px;
      height: 18px;
      background-color: #9b9b9b;
      border-radius: 100%;
      color: #fff;
      &::before {
        position: absolute;
        top: -9px;
        left: 0;
      }
    }
    .inner {
      width: 90%;
      padding: 10px 0;
      margin: 0 auto;
    }
    .form-control {
      height: 36px;
      border-radius: 18px;
      border: 0;
      background: #f1f1f1;
      font-size: 14px;
      line-height: 36px;
      padding: 0 20px 0 36px;
    }
    .col-10 {
      padding-right: 0;
    }
    .col-2 {
      color: #4a4a4a;
      font-size: 14px;
      padding: 0;
      text-align: center;
      .btn {
        border: 0;
        padding-left: 0;
        padding-right: 0;
        &.searchable {
          color: #e42029;
        }
      }
      .gradBtn {
        color: #929292;
      }
      .redBtn {
        color: #e42029;
      }
    }
  }
}
</style>
